import { AuthStore } from "../store/authStore";

let socket = undefined;
let _handler;
let _metricsHandler;
let lastTopics;

const streamUrl =
  process.env.REACT_APP_ENV === "development"
    ? "wss://api-stream-dev.code4pro.com"
    : "wss://api-stream.code4pro.com";

export async function connect() {
  let authToken = AuthStore.session.getIdToken().getJwtToken();

  if (socket === undefined) {
    socket = new WebSocket(`${streamUrl}?Authorization=${authToken}`);

    socket.onopen = (event) => {
      console.log("connected");
      if (lastTopics) {
        subscribe(lastTopics);
      }
    };

    socket.onmessage = function (e) {
      if (_handler) {
        _handler(JSON.parse(e.data));
      }
      if (_metricsHandler) {
        _metricsHandler(JSON.parse(e.data));
      }
    };

    socket.onclose = function (e) {
      socket = undefined;
      console.log(
        "Socket is closed. Reconnect will be attempted in 1 second.",
        e.reason
      );
      setTimeout(function () {
        connect();
      }, 1000);
    };

    socket.onerror = function (err) {
      console.error(
        "Socket encountered error: ",
        err.message,
        "Closing socket"
      );
      socket.close();
    };
  }
}

export function registerHandler(handler) {
  _handler = handler;
}

export function registerMetricsHandler(handler) {
  _metricsHandler = handler;
}

function debounce(func, timeout = 1000) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

const debounce_subs = debounce(() => _subscribe());

export async function subscribe(topics) {
  lastTopics = Array.from(topics);
  debounce_subs();
}

async function _subscribe() {
  console.log("subscribing ", lastTopics);
  if (lastTopics.length === 0) {
    return;
  }
  if (socket.readyState === WebSocket.OPEN) {
    console.log("Sending subscription");
    socket.send(
      JSON.stringify({
        action: "subscribe",
        body: { topics: Array.from(lastTopics) },
      })
    );
    lastTopics = [];
  } else {
    console.log("socket is not in ready state. state=" + socket.readyState);
  }
}

export async function sendSimulation(payload) {
  socket.send(
    JSON.stringify({
      action: "simulation",
      body: payload,
    })
  );
}
